// extracted by mini-css-extract-plugin
export default {"map":"MapAbout_map__wQxbw"};